//GET ALL
export const RECEIPT_LIST_REQUEST = "RECEIPT_LIST_REQUEST";
export const RECEIPT_LIST_SUCCESS = "RECEIPT_LIST_SUCCESS";
export const RECEIPT_LIST_FAIL = "RECEIPT_LIST_FAIL"


export const RECEIPT_LIST_CLEAR_ERROR = "CLEAR_ERROR"